import { RevamppCore, RevamppProject } from "../../../secure/list-management/scripts/list-management.objects";
import { plainToClass } from "class-transformer";

declare var $: any;
declare var grecaptcha: ReCaptchaV2.ReCaptcha;

export class RequestAccountPage{
    centerDropdown: JQuery<HTMLElement>;

    affiliationSelectContainer: JQuery<HTMLElement>;
    affiliationCoreSelect: JQuery<HTMLElement>;
    affiliationProjectSelect: JQuery<HTMLElement>;
    affiliationNoneSelect: JQuery<HTMLElement>;

    coreDropdown: JQuery<HTMLElement>;
    coreContainer: JQuery<HTMLElement>;

    projectDropdown: JQuery<HTMLElement>;
    projectContainer: JQuery<HTMLElement>;

    coreList: RevamppCore[];
    projectList: RevamppProject[];

    requestAccountBtn: JQuery<HTMLElement>;

    errorMessageAll: JQuery<HTMLElement>;
    submitSpinner: JQuery<HTMLElement>;

    recaptchaPublicKey: string;
    recaptchaWidgetId: number = -99;
    recapthcaToken: string;

    constructor(coreJson: any, projectJson: any) {
        $(() => {
            this.centerDropdown = $("#Input_CenterId");

            this.affiliationSelectContainer = $("#affiliation-type-container");
            this.affiliationCoreSelect = $("#affiliationTypeCore");
            this.affiliationProjectSelect = $("#affiliationTypeProject");
            this.affiliationNoneSelect = $("#affiliationTypeNone");

            this.coreDropdown = $("#Input_CoreId");
            this.coreContainer = $("#core-form-container");

            this.projectDropdown = $("#Input_ProjectId");
            this.projectContainer = $("#project-form-container");

            this.coreList = plainToClass(RevamppCore, <RevamppCore[]>coreJson);
            this.projectList = plainToClass(RevamppProject, <RevamppProject[]>projectJson);

            this.requestAccountBtn = $("#request-account-btn");

            this.errorMessageAll = $("#all-error-message");
            this.submitSpinner = $("#submit-spinner");

            this.initializeListeners();
        })
    }

    initializeListeners(): void {
        // Change Affiliation Type
        this.affiliationSelectContainer.on("change", () => {
            if (this.affiliationCoreSelect.is(":checked")) {
                this.projectDropdown.selectpicker("val", "0");
                this.coreContainer.removeClass("d-none");
                this.projectContainer.addClass("d-none");
            }
            else if (this.affiliationProjectSelect.is(":checked")) {
                this.coreDropdown.selectpicker("val", "0");
                this.coreContainer.addClass("d-none");
                this.projectContainer.removeClass("d-none");
            }
            else if (this.affiliationNoneSelect.is(":checked")) {
                this.projectDropdown.selectpicker("val", "0");
                this.coreDropdown.selectpicker("val", "0");
                this.projectContainer.addClass("d-none");
                this.coreContainer.addClass("d-none");
            }
        });

        // Change Center
        this.centerDropdown.on("changed.bs.select", () => {
            // Get searched center
            let searchedCenter: string = <string>this.centerDropdown.val();

            // remove existing options
            this.coreDropdown.empty();
            this.projectDropdown.empty();

            // Create dropdown for core/project
            let foundCores = this.coreList.filter(core => core.CenterId.toString() == searchedCenter);
            foundCores.sort((x1, x2) => x1.CoreName.localeCompare(x2.CoreName));
            foundCores.forEach(core => {
                this.coreDropdown.append(`<option value="${core.Id}">${core.CoreName}</option>`);
            })

            let foundProjects = this.projectList.filter(project => project.CenterId.toString() == searchedCenter);
            foundProjects.sort((x1, x2) => x1.ProjectName.localeCompare(x2.ProjectName));
            foundProjects.forEach(project => {
                this.projectDropdown.append(`<option value="${project.Id}">${project.ProjectName}</option>`);
            })

            this.coreDropdown.selectpicker("refresh");
            this.projectDropdown.selectpicker("refresh");

            // If there are no cores or projects, default to N/A
            if (foundCores.length == 0 && foundProjects.length == 0) {
                this.affiliationNoneSelect.prop("checked", true).trigger("change");
            }
            else {
                this.affiliationCoreSelect.prop("checked", true).trigger("change");
            }
        });

        // Disable Default Behavior for submit button
        this.requestAccountBtn.on("click", async (e) => {
            e.preventDefault();
            let isValid = this.validateForm();

            if (isValid) {
                let accountRequest: NewAccountRequest = this.createAccountRequest();
                this.requestAccountBtn.addClass("d-none");
                this.submitSpinner.removeClass("d-none");
                await this.submitForm(accountRequest);
            }
            else {
                $("html, body").animate({
                    scrollTop: 0
                }, 600);
            }
        })
    }

    verifyReCaptcha(): boolean {
        let isValid = true;

        let response = grecaptcha.getResponse();

        if (!response) {
            isValid = false;
            $("#recaptcha-error-msg").removeClass('d-none');
        }
        else {
            this.recapthcaToken = response;
            $("#recaptcha-error-msg").addClass('d-none');
        }

        return isValid;
    }

    private validateForm(): boolean {
        let isValid = true;

        // get all of the required form field label
        $(".required:visible").toArray().forEach(element => {
            let errorMessage = $(element).parent().find(".text-danger");

            let inputField = $(element).siblings("input").not(".email-input, .url-input").first();
            if (inputField.length != 0) {
                let val = <string>inputField.val();
                if (!val) {
                    isValid = false;
                    errorMessage.removeClass("d-none");
                }
                else {
                    errorMessage.addClass("d-none");
                }
            }

            let emailInput = $(element).siblings(".email-input").first();
            if (emailInput.length != 0) {
                let val = <string>emailInput.val();
                if (!val) {
                    isValid = false;
                    errorMessage.removeClass('d-none');
                }
                else {
                    let trimmedVal = val.trim();
                    if (trimmedVal.includes(" ") || !trimmedVal.includes("@")) {
                        isValid = false;
                        errorMessage.removeClass('d-none');
                    }
                    else {
                        errorMessage.addClass("d-none");
                    }
                }             
            }

            let selectField = $(element).parent().find("select").first();
            if (selectField.length != 0) {
                let val = <string>selectField.val();
                if (!val) {
                    isValid = false;
                    errorMessage.removeClass("d-none");
                }
                else {
                    errorMessage.addClass("d-none");
                }
            }            
        });

        // Validation
        $(".url-input").toArray().forEach(element => {
            let errorMessage: JQuery<HTMLElement> = $(element).parent().find(".text-danger");

            let urlVal: string = $(element).val();
            if (urlVal != "") {
                let trimmedUrl = urlVal.trim();
                // ORCID
                if ($(element).hasClass("orcid-url")) {
                    if (!trimmedUrl.startsWith("https://") || trimmedUrl.includes(" ") || !trimmedUrl.includes("orcid.org")) {
                        isValid = false;
                        errorMessage.removeClass("d-none");
                    }
                    else {
                        errorMessage.addClass("d-none");
                    }
                }
                // Linkedin
                else if ($(element).hasClass("linkedin-url")) {
                    if (!trimmedUrl.startsWith("https://") || trimmedUrl.includes(" ") || !trimmedUrl.includes("linkedin.com")) {
                        isValid = false;
                        errorMessage.removeClass("d-none");
                    }
                    else {
                        errorMessage.addClass("d-none");
                    }
                }
                // Other URL
                else {
                    if (!trimmedUrl.startsWith("https://") || trimmedUrl.includes(" ")) {
                        isValid = false;
                        errorMessage.removeClass("d-none");
                    }
                    else {
                        errorMessage.addClass("d-none");
                    }
                }
                
            }
            else {
                errorMessage.addClass("d-none");
            }
        });

        if (isValid) {
            this.errorMessageAll.addClass("d-none");

            let recaptchaCheck = this.verifyReCaptcha();
            if (!recaptchaCheck) {
                isValid = false;
            }
        }
        else {
            this.errorMessageAll.removeClass("d-none");
        }


        return isValid;
    }

    private createAccountRequest(): NewAccountRequest {
        let accountRequest = new NewAccountRequest();

        // Contact Information
        let email = <string>$("#Input_Email").val();
        if (email) accountRequest.Email = email.trim();

        let firstName = <string>$("#Input_FirstName").val();
        if (firstName) accountRequest.FirstName = firstName.trim();

        let lastName = <string>$("#Input_LastName").val();
        if (lastName) accountRequest.LastName = lastName.trim();

        let orgName = <string>$("#Input_OrganizationName").val();
        if (orgName) accountRequest.OrganizationName = orgName.trim();

        // Affiliation
        let roleIdStr = <string>$("#Input_RoleId").val();
        if (roleIdStr) {
            let roleId = parseInt(roleIdStr);
            if (roleId) accountRequest.RoleId = roleId;
        }
        let centerIdStr = <string>$("#Input_CenterId").val();
        if (centerIdStr) {
            let centerId = parseInt(centerIdStr);
            if (centerId) accountRequest.CenterId = centerId;
        }
        let coreIdStr = <string>$("#Input_CoreId").val();
        if (coreIdStr) {
            let coreId = parseInt(coreIdStr);
            if (coreId) accountRequest.CoreId = coreId;
        }
        let projectIdStr = <string>$("#Input_ProjectId").val();
        if (projectIdStr) {
            let projectId = parseInt(projectIdStr);
            if (projectId) accountRequest.ProjectId = projectId;
        }

        // Bio
        let terminalIdArr = <string[]>$("#Input_TerminalDegreeArr").val();
        if (terminalIdArr.length > 0) accountRequest.TerminalDegreeIds = terminalIdArr.join("|");

        let orcidLink = <string>$("#Input_OrcidLink").val();
        if (orcidLink) accountRequest.OrcidLink = orcidLink.trim();

        let linkedinLink = <string>$("#Input_LinkedInLink").val();
        if (linkedinLink) accountRequest.LinkedinLink = linkedinLink.trim();

        let bioLink = <string>$("#Input_ExternalBioLink").val();
        if (bioLink) accountRequest.BioLink = bioLink.trim();

        return accountRequest;
    }

    private async submitForm(accountRequest: NewAccountRequest): Promise<void> {
        let token = this.recapthcaToken;
        if (!token) {
            return;
        }

        let result: any
        try {
            result = await $.ajax({
                url: `/auth/pages/request-account/request-account?handler=Submit`,
                method: "POST",
                headers: { "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() },
                data: { data: JSON.stringify(accountRequest), recaptchaToken: token},
            });
            // redirect to submission page
            window.location.href = "/account-request-submitted";
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        } 
    }
}

class NewAccountRequest {
    Email: string;
    FirstName: string;
    LastName: string;
    OrganizationName: string;

    RoleId: number = 0;
    CenterId: number = 0;
    CoreId: number = 0;
    ProjectId: number = 0;

    TerminalDegreeIds: string = "";
    OrcidLink: string = "";
    LinkedinLink: string = "";
    BioLink: string = "";
}